import { cn } from "@/lib/cn";

/** A single line of configurable quick-hour buttons. Adds to the active hours field. */
export function PresetLine({ presets = [], onAdd, disabled, size = "sm" }) {
  return (
    <div className="flex flex-nowrap items-center gap-1.5 overflow-x-auto" data-testid="preset-line">
      <span className="shrink-0 text-xs font-medium text-muted-foreground">Quick add:</span>
      {presets.map((h, i) => (
        <button
          key={`${h}-${i}`}
          type="button"
          data-testid={`preset-${h}`}
          disabled={disabled}
          onClick={() => onAdd(h)}
          className={cn(
            "shrink-0 rounded-md border border-border bg-surface font-sans font-medium text-muted-foreground transition-colors hover:bg-accent hover:text-foreground disabled:opacity-40",
            size === "lg" ? "px-4 py-2 text-base" : "px-2.5 py-1 text-xs"
          )}
        >
          +{h}
        </button>
      ))}
      {presets.length === 0 && (
        <span className="text-xs text-muted-foreground">No presets — add some in Settings.</span>
      )}
    </div>
  );
}
